import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000, // One minute
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
